module.exports = new __parcel__URL__("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg").toString();